export default "__VITE_ASSET__BvAx6UEr__"